import { useRequest, useAuth } from "@onefront/react-sdk";
import { useCurrentTenant } from "@drift/oneplatfront";
import { generateHeaders } from "../../../utils/generate-headers";

interface IParamsFetch {
    params?: any;
    headers?: any;
    data: any;
    url?: string;
}

interface IusePatchAdditionalBusinessDetails {
    (workspaceId?: string, businessId?: string, service?: string, params?: any | object, lazy?: boolean): {
        data?: any;
        loading?: boolean;
        fetch: (fetchConfig: IParamsFetch) => Promise<any>;
        error: boolean;
    };
}

export const usePatchAdditionalBusinessDetails: IusePatchAdditionalBusinessDetails = (
    workspaceId,
    businessId,
    service,
    serviceId
) => {
    const { tenant } = useCurrentTenant(true);
    return useRequest({
        method: "patch",
        headers: generateHeaders(useAuth(), tenant?.itemId, workspaceId),
        url: `rnd:core:workspace-write:api://v1/workspaces/${workspaceId}/business/${businessId}/${service}/${serviceId}`,
        lazy: true
    });
};
